import {
  Box,
  Button,
  Divider,
  FormControl,
  FormLabel,
  Icon,
  Select,
  SimpleGrid,
  Text,
} from "@chakra-ui/core";
import React, { Fragment, useState } from "react";
import CardFooter from "../CardFooter";

const CourseDetails = () => (
  <Fragment>
    <SimpleGrid marginY="1.5em" minChildWidth="120px" spacing="1em">
      <FormControl>
        <FormLabel>Course</FormLabel>
        <Select placeholder="Bachelor Degree" />
      </FormControl>
      <FormControl>
        <FormLabel>Specialization</FormLabel>
        <Select placeholder="Graphics" />
      </FormControl>
    </SimpleGrid>
    <SimpleGrid marginY="1.5em" minChildWidth="120px" spacing="1em">
      <FormControl>
        <FormLabel>Course Type</FormLabel>
        <Select placeholder="Short Term" />
      </FormControl>
    </SimpleGrid>
    <SimpleGrid marginY="1.5em" minChildWidth="120px" spacing="1em">
      <FormControl>
        <FormLabel>University</FormLabel>
        <Select placeholder="St.Oxford" />
      </FormControl>
      <FormControl>
        <FormLabel>Year of Passing</FormLabel>
        <Select placeholder="2009" />
      </FormControl>
    </SimpleGrid>
  </Fragment>
);

function Eligibility() {
  const [CourseCards, setCC] = useState([CourseDetails]);

  const handleCC = () => {
    setCC([...CourseCards, CourseDetails]);
  };
  // const decreaseCC = (index) => {
  //     setCC(CourseCards.splice(index, 0, 1))
  // };

  return (
    <Box p="10">
      <Text fontSize="2xl">Course Details</Text>
      <Divider marginBottom="2em" />
      {CourseCards.map((CC, index) => (
        <CC key={`abc${index + 1}`} />
      ))}
      <Button rounded="full" padding="0" boxShadow="lg" onClick={handleCC}>
        <Icon name="add" />
      </Button>
      <CardFooter />
    </Box>
  );
}

export default Eligibility;
